import * as React from "react";
import type { SVGProps } from "react";
const SvgCalendar03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6.514 7.5H17.4m-11.629-6v1.8M18 1.5v1.8m3.6 3v13.2a3 3 0 0 1-3 3H5.4a3 3 0 0 1-3-3V6.3a3 3 0 0 1 3-3h13.2a3 3 0 0 1 3 3"
    />
  </svg>
);
export default SvgCalendar03;
